import React, { FC } from "react";

import Grid from "@mui/material/Grid";

import { ButtonMenu, Logo } from "@/components/atoms";
import { Help, LanguageSelector } from "@/components/molecules";
import { useNavigation, useRouterHook } from "@/shared/hooks";

import { StyledLogoGridItem, StyledMenuGridItem } from "../../styled";
import LoginNavigation from "../LoginNavigation/LoginNavigation";
import { StyledNoAuthHeader } from "./styled";

type NotAuthenticatedHeaderProps = {
    light?: boolean;
    lightMenu?: boolean;
    lightMenuSmallInverted?: boolean;
    displayLoginNavigation?: boolean;
};

const NotAuthenticatedHeader: FC<NotAuthenticatedHeaderProps> = ({
    light = false,
    lightMenu = false,
    lightMenuSmallInverted = false,
    displayLoginNavigation = false,
}) => {
    const {
        globalState: { officeId },
    } = useRouterHook();

    const { navToRoot } = useNavigation();

    return (
        <>
            <Logo variant="favicon" officeId={officeId} />
            <StyledNoAuthHeader>
                <Grid container item xs={12} className="row">
                    <StyledLogoGridItem item xs={5}>
                        <ButtonMenu aria-label="MyBroker" className="logo" onClick={() => navToRoot(officeId)}>
                            <div className="logoDisplayer">
                                <Logo officeId={officeId} variant={light ? "light" : "default"} />
                            </div>
                        </ButtonMenu>
                    </StyledLogoGridItem>
                    <StyledMenuGridItem
                        $lightMenu={lightMenu}
                        $lightMenuSmallInverted={lightMenuSmallInverted}
                        item
                        xs={7}
                    >
                        <div className="header-components-action">
                            {displayLoginNavigation && <LoginNavigation />}
                            <Help />
                            <LanguageSelector />
                        </div>
                    </StyledMenuGridItem>
                </Grid>
            </StyledNoAuthHeader>
        </>
    );
};

export default NotAuthenticatedHeader;
